<div class="card-header bg-success">
    <div class="row">
        <div class="col-md-6">
            <h3>Saddlery & Tack Report</h3>
        </div>
    </div>
</div>
<div class="card-body">
    <!-- Tab Navigation -->
    <ul class="nav nav-tabs mb-3" role="tablist">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'master'" (click)="activeTab = 'master'" 
               role="tab" style="cursor: pointer;">Master BDX</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'transacted'" (click)="activeTab = 'transacted'" 
               role="tab" style="cursor: pointer;">Transacted BDX</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'paid'" (click)="activeTab = 'paid'" 
               role="tab" style="cursor: pointer;">Paid BDX</a>
        </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content">
        <!-- Master BDX Tab -->
        <div *ngIf="activeTab === 'master'">
            <form #masterForm="ngForm" (ngSubmit)="onSubmit(masterForm, 'master')">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <div class="col-md-4">Start Date</div>
                            <div class="col-md-8">
                                <input type="text" required name="master_start_date" placeholder="Start Date"
                                    class="form-control form-control-sm datepicker" matInput (focus)="masterStartDatepicker.open()"
                                    [matDatepicker]="masterStartDatepicker" [(ngModel)]="masterStartDate"
                                    #master_start_date="ngModel"
                                    [ngClass]="{ 'is-invalid': masterForm.submitted && master_start_date.invalid }">
                                <mat-datepicker-toggle [for]="masterStartDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #masterStartDatepicker></mat-datepicker>
                                <div *ngIf="masterForm.submitted && master_start_date.invalid" class="invalid-feedback">
                                    Start date is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-4">End Date</div>
                            <div class="col-md-8">
                                <input type="text" required name="master_end_date" placeholder="End Date"
                                    class="form-control form-control-sm datepicker" matInput (focus)="masterEndDatepicker.open()"
                                    [matDatepicker]="masterEndDatepicker" [(ngModel)]="masterEndDate"
                                    #master_end_date="ngModel"
                                    [ngClass]="{ 'is-invalid': masterForm.submitted && master_end_date.invalid }">
                                <mat-datepicker-toggle [for]="masterEndDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #masterEndDatepicker></mat-datepicker>
                                <div *ngIf="masterForm.submitted && master_end_date.invalid" class="invalid-feedback">
                                    End date is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-success btn-gray" type="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Transacted BDX Tab -->
        <div *ngIf="activeTab === 'transacted'">
            <form #transactedForm="ngForm" (ngSubmit)="onSubmit(transactedForm, 'transacted')">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <div class="col-md-4">Start Date</div>
                            <div class="col-md-8">
                                <input type="text" required name="transacted_start_date" placeholder="Start Date"
                                    class="form-control form-control-sm datepicker" matInput (focus)="transactedStartDatepicker.open()"
                                    [matDatepicker]="transactedStartDatepicker" [(ngModel)]="transactedStartDate"
                                    #transacted_start_date="ngModel"
                                    [ngClass]="{ 'is-invalid': transactedForm.submitted && transacted_start_date.invalid }">
                                <mat-datepicker-toggle [for]="transactedStartDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #transactedStartDatepicker></mat-datepicker>
                                <div *ngIf="transactedForm.submitted && transacted_start_date.invalid" class="invalid-feedback">
                                    Start date is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-4">End Date</div>
                            <div class="col-md-8">
                                <input type="text" required name="transacted_end_date" placeholder="End Date"
                                    class="form-control form-control-sm datepicker" matInput (focus)="transactedEndDatepicker.open()"
                                    [matDatepicker]="transactedEndDatepicker" [(ngModel)]="transactedEndDate"
                                    #transacted_end_date="ngModel"
                                    [ngClass]="{ 'is-invalid': transactedForm.submitted && transacted_end_date.invalid }">
                                <mat-datepicker-toggle [for]="transactedEndDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #transactedEndDatepicker></mat-datepicker>
                                <div *ngIf="transactedForm.submitted && transacted_end_date.invalid" class="invalid-feedback">
                                    End date is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-success btn-gray" type="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Paid BDX Tab -->
        <div *ngIf="activeTab === 'paid'">
            <form #paidForm="ngForm" (ngSubmit)="onSubmit(paidForm, 'paid')">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <div class="col-md-4">Start Date</div>
                            <div class="col-md-8">
                                <input type="text" required name="paid_start_date" placeholder="Start Date"
                                    class="form-control form-control-sm datepicker" matInput (focus)="paidStartDatepicker.open()"
                                    [matDatepicker]="paidStartDatepicker" [(ngModel)]="paidStartDate"
                                    #paid_start_date="ngModel"
                                    [ngClass]="{ 'is-invalid': paidForm.submitted && paid_start_date.invalid }">
                                <mat-datepicker-toggle [for]="paidStartDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #paidStartDatepicker></mat-datepicker>
                                <div *ngIf="paidForm.submitted && paid_start_date.invalid" class="invalid-feedback">
                                    Start date is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-4">End Date</div>
                            <div class="col-md-8">
                                <input type="text" required name="paid_end_date" placeholder="End Date"
                                    class="form-control form-control-sm datepicker" matInput (focus)="paidEndDatepicker.open()"
                                    [matDatepicker]="paidEndDatepicker" [(ngModel)]="paidEndDate"
                                    #paid_end_date="ngModel"
                                    [ngClass]="{ 'is-invalid': paidForm.submitted && paid_end_date.invalid }">
                                <mat-datepicker-toggle [for]="paidEndDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #paidEndDatepicker></mat-datepicker>
                                <div *ngIf="paidForm.submitted && paid_end_date.invalid" class="invalid-feedback">
                                    End date is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-success btn-gray" type="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>